import { BotIcon } from 'lucide-react'
import { memo, type ReactNode } from 'react'

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { getInitials } from '@/lib/initials.util'

import type { ChatParticipant, MessageSender } from './chat-message.interface'

interface ChatMessageAvatarProps {
  sender: MessageSender
  participant?: ChatParticipant
}

/**
 * Avatar component for chat messages, showing bot icon for assistant or user initials/image.
 */
const ChatMessageAvatarBase: React.FC<ChatMessageAvatarProps> = ({
  sender,
  participant,
}): ReactNode => {
  if (sender === 'assistant') {
    return (
      <Avatar className="size-8">
        <AvatarFallback className="bg-primary text-primary-foreground">
          <BotIcon className="size-4" />
        </AvatarFallback>
      </Avatar>
    )
  }

  return (
    <Avatar className="size-8">
      {participant?.avatarUrl && <AvatarImage src={participant.avatarUrl} alt={participant.name} />}
      <AvatarFallback className="text-xs">
        {participant ? getInitials(participant.name) : '?'}
      </AvatarFallback>
    </Avatar>
  )
}

export const ChatMessageAvatar = memo(ChatMessageAvatarBase)

ChatMessageAvatar.displayName = 'ChatMessageAvatar'
